<template>
  <div>
    <div class="mbox">
      <div class="txt-h5 caps">
        {{ T__("Invitee Questions") }}
        <a
          href="https://help.wpcal.io/en/article/event-type-questions-forms-1mt8d6a/?utm_source=wpcal_plugin&utm_medium=contextual"
          target="_blank"
          class="icon-q-mark"
        ></a>
      </div>
      <div class="txt-help">
        {{
          T__(
            "Invitees will be asked to fill out their full name and email to book this event."
          )
        }}
      </div>
      <div class="wpc-form-row">
        <div class="txt-h5 mt20">{{ T__("Full Name") }}</div>
        <input type="text" readonly />
      </div>
      <div class="wpc-form-row">
        <div class="txt-h5 mt20">{{ T__("Email") }}</div>
        <input type="text" readonly />
      </div>

      <div
        v-drag-and-drop:options="
          questions.length > 1 ? questions_drag_drop_options : {}
        "
        :key="questions.length > 1 ? 100 : 0"
      >
        <!-- :key helps in re-render drag and drop -->
        <div id="question_answers_cont" @reordered="reorder_selected_question">
          <div
            class="wpc-form-row invitee-question"
            v-for="(question, index) in questions"
            :key="index"
            @mouseover="question_mouseover_index = index"
            @mouseleave="question_mouseover_index = null"
            :class="{
              hover: question_mouseover_index === index,
              disabled: !question.is_enabled || question.is_enabled == 0
            }"
            :id="'question_index_' + index"
            :data-id="index"
          >
            <hr />
            <div class="txt-h5">
              <div :class="{ 'reorder-handle': questions.length > 1 }"></div>
              <a class="edit-question-link" @click="edit_question(index)">{{
                T__("EDIT")
              }}</a>
              <!-- for using pre -->
              <!-- eslint-disable-next-line -->
              <span class="pre question_title">{{ question.question }}</span>
            </div>
            <textarea
              v-if="question.answer_type == 'textarea'"
              readonly
              class="answer_type_input"
            />
            <input
              type="text"
              v-if="
                question.answer_type == 'input_text' ||
                  question.answer_type == 'input_phone'
              "
              readonly
            />
          </div>
        </div>
      </div>
      <hr style="margin-top:0;" />
      <button
        type="button"
        class="wpc-btn secondary md"
        style="width:100%"
        @click="add_question"
        id="add_question"
        :disabled="!can_active_add_question_btn"
      >
        {{ T__("+ Add Question") }}
      </button>
    </div>
    <div
      id="edit_question_popup"
      v-show="can_show_edit_question_popup"
      style="z-index:10000; width:360px;"
      class="popper-cont"
    >
      <div class="mbox shadow">
        <div data-popper-arrow class="popper_arrow"></div>
        <div class="txt-h5 bold" style="display:flex;">
          {{
            this.current_edit_question_index == "new"
              ? this.T__("Add")
              : this.T__("Edit")
          }}
          {{ T__("Question") }}
          <OnOffSlider
            name="current_edit_question_is_enabled"
            v-model="current_edit_question.is_enabled"
            true_value="1"
            false_value="0"
          />

          <div
            class="delete"
            @click="show_delete_confirmation"
            v-if="this.current_edit_question_index != 'new'"
          >
            {{ T__("Delete question") }}
          </div>
        </div>
        <div class="wpc-form-row">
          <div class="txt-h5 mt20">{{ T__("Answer type") }}</div>
          <form-row :validator="$v.current_edit_question.answer_type">
            <select
              v-model="current_edit_question.answer_type"
              @change="$v.current_edit_question.answer_type.$touch()"
            >
              <option value="textarea">{{ T__("Multi-line") }}</option>
              <option value="input_text">{{ T__("Single-line") }}</option>
              <option value="input_phone">{{ T__("Phone") }}</option>
            </select>
          </form-row>
          <div class="txt-h5 mt20">{{ T__("Question") }}</div>
          <form-row :validator="$v.current_edit_question.question">
            <textarea
              v-model="current_edit_question.question"
              @blur="$v.current_edit_question.question.$touch()"
            />
          </form-row>
          <label
            ><input
              type="checkbox"
              v-model="current_edit_question.is_required"
              true-value="1"
              false-value="0"
            />{{ T__("Required") }}</label
          >
          <div class="txt-h5 mt20">{{ T__("Answer") }}</div>
          <textarea
            v-if="current_edit_question.answer_type == 'textarea'"
            readonly
          />
          <input
            type="text"
            v-if="
              current_edit_question.answer_type == 'input_text' ||
                current_edit_question.answer_type == 'input_phone'
            "
            readonly
          />
          <button
            class="wpc-btn primary md mt20 full-width"
            @click="save_question"
          >
            {{ T__("Done") }}
          </button>
          <button
            class="wpc-btn tert-link sm mt10 center"
            @click="reset_current_question_and_hide_edit_question_popup"
          >
            {{ T__("Cancel") }}
          </button>
        </div>
      </div>
    </div>
    <!-- <v-dialog style="z-index:10001;" /> -->
  </div>
</template>

<script>
import { VueDraggableDirective } from "vue-draggable";

import OnOffSlider from "@/components/form_elements/OnOffSlider.vue";

import { createPopper } from "@popperjs/core";

import {
  required
  // requiredIf,
  // minLength,
  // integer
} from "vuelidate/lib/validators";

import { must_be_1_or_0, in_array } from "@/utils/common_func.js";

export default {
  components: {
    OnOffSlider
  },
  directives: {
    dragAndDrop: VueDraggableDirective
  },
  model: {
    prop: "invitee_questions",
    event: "invitee-questions-changed"
  },
  props: {
    invitee_questions: {
      type: Object,
      default: function() {
        return { questions: [] };
      }
    }
  },
  data() {
    return {
      can_show_edit_question_popup: false,
      edit_question_popup_instance: null,
      current_edit_question: {},
      current_edit_question_index: false,
      default_question: {
        is_enabled: "1",
        is_required: "0",
        question: this.T__(
          "Please share anything that will help prepare for our meeting."
        ),
        answer_type: "textarea"
      },
      question_mouseover_index: null,
      questions_drag_drop_options: {
        dropzoneSelector: "#question_answers_cont",
        draggableSelector: ".invitee-question",
        handlerSelector: ".reorder-handle",
        reactivityEnabled: true,
        multipleDropzonesItemsDraggingEnabled: false,
        showDropzoneAreas: true
      }
    };
  },
  validations: {
    current_edit_question: {
      is_enabled: { required, must_be_1_or_0 },
      is_required: { required, must_be_1_or_0 },
      question: { required },
      answer_type: {
        required,
        answer_type_in_array: in_array([
          "textarea",
          "input_text",
          "input_phone"
        ])
      }
    }
  },
  computed: {
    can_active_add_question_btn() {
      if (
        !this.invitee_questions ||
        typeof this.invitee_questions !== "object" ||
        !this.invitee_questions.hasOwnProperty("questions") ||
        !Array.isArray(this.invitee_questions.questions)
      ) {
        //these checks are used because computed property calls even before "created" lifecycle
        return false;
      }
      return this.invitee_questions.questions.length < 10;
      //return true;
    },
    questions() {
      if (
        !this.invitee_questions ||
        typeof this.invitee_questions !== "object" ||
        !this.invitee_questions.hasOwnProperty("questions")
      ) {
        return [];
      }
      return this.invitee_questions.questions;
    }
  },
  methods: {
    add_question() {
      //if (this.invitee_questions.questions.length == 0) {
      this.current_edit_question_index = "new";
      this.current_edit_question = this.clone_deep(this.default_question);
      if (this.invitee_questions.questions.length >= 1) {
        this.current_edit_question.question = "";
      }
      this.$v.current_edit_question.$reset();
      this.show_edit_question_popup();
      //}
    },
    edit_question(index) {
      if (typeof this.invitee_questions.questions[index] === "object") {
        this.current_edit_question_index = index;
        this.current_edit_question = this.clone_deep(
          this.invitee_questions.questions[index]
        );
        this.$v.current_edit_question.$reset();
        this.show_edit_question_popup(index);
      }
    },
    delete_question() {
      if (Number.isInteger(this.current_edit_question_index)) {
        this.invitee_questions.questions.splice(
          this.current_edit_question_index,
          1
        );
      } else if (this.current_edit_question_index === "new") {
        this.current_edit_question = {};
      }
      this.$emit("invitee-questions-changed", this.invitee_questions);
      this.$emit("save-questions");
      this.reset_current_question_and_hide_edit_question_popup();
    },
    save_question() {
      this.$v.current_edit_question.$touch();
      if (this.$v.current_edit_question.$anyError) {
        this.scroll_to_first_validation_error();
        return false;
      }

      if (Number.isInteger(this.current_edit_question_index)) {
        this.invitee_questions.questions[
          this.current_edit_question_index
        ] = this.current_edit_question;
      } else if (this.current_edit_question_index === "new") {
        this.invitee_questions.questions.push(this.current_edit_question);
      }
      this.$emit("invitee-questions-changed", this.invitee_questions);
      this.$emit("save-questions");
      this.reset_current_question_and_hide_edit_question_popup();
    },
    show_delete_confirmation() {
      /*let button_str = this.T__("Delete");*/
      this.$modal.show("dialog", {
        title: this.T__("Delete this question?"),
        text: "",
        buttons: [
          {
            title: this.T__("Yes, delete."),
            class: "vue-dialog-button dialog-red-btn",
            handler: () => {
              this.delete_question();
              this.$modal.hide("dialog");
            }
          },
          {
            title: "No, don't.",
            handler: () => {
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    show_edit_question_popup(q_index = null) {
      let element_selector = "#add_question";
      if (q_index !== null) {
        element_selector = "#question_index_" + q_index;
      }
      this.can_show_edit_question_popup = true;
      const element = document.querySelector(element_selector);
      const tooltip = document.querySelector("#edit_question_popup");

      if (this.edit_question_popup_instance !== null) {
        this.edit_question_popup_instance.destroy();
        this.edit_question_popup_instance = null;
      }

      this.edit_question_popup_instance = createPopper(element, tooltip, {
        placement: "right",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 20]
            }
          }
        ]
      });
    },
    hide_edit_question_popup() {
      this.can_show_edit_question_popup = false;
    },
    reset_current_question_and_hide_edit_question_popup() {
      this.hide_edit_question_popup();
      this.current_edit_question_index = false;
      this.current_edit_question = {};
    },
    reorder_selected_question(event) {
      let move_item_old_index = event.detail.ids[0];
      let move_item_new_index = event.detail.index;
      let moved_item = this.invitee_questions.questions.splice(
        move_item_old_index,
        1
      );
      let final_item_new_index =
        move_item_old_index < move_item_new_index
          ? move_item_new_index - 1
          : move_item_new_index;
      // console.log(
      //   move_item_old_index,
      //   "to",
      //   move_item_new_index,
      //   "final",
      //   final_item_new_index
      // );
      this.invitee_questions.questions.splice(
        final_item_new_index,
        0,
        moved_item[0]
      );
      this.$nextTick(() => {
        this.$emit("save-questions");
      });
    }
    // normalise_empty_invitee_questions() {
    //   if (
    //     !this.invitee_questions ||
    //     typeof this.invitee_questions !== "object" ||
    //     !this.invitee_questions.hasOwnProperty("questions") ||
    //     !Array.isArray(this.invitee_questions.questions)
    //   ) {
    //     let default_invitee_questions = { questions: [] };
    //     this.$emit("invitee-questions-changed", default_invitee_questions);
    //   }
    // }
  }
};
</script>
<style scoped>
.wpc-form-row.invitee-question a.edit-question-link {
  float: right;
  margin-left: 10px;
}
#edit_question_popup .txt-h5 .delete {
  float: right;
  color: #e84653;
  font-size: 13px;
  margin-top: 1px;
  font-weight: normal;
  margin-left: auto;
}
#edit_question_popup .txt-h5 .delete:hover {
  text-decoration: underline;
  cursor: pointer;
}
#edit_question_popup .txt-h5 .delete::before {
  content: "";
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22.5 22.5'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23e84653;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Eicon-trash%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cline class='cls-1' x1='0.75' y1='3.75' x2='21.75' y2='3.75'/%3E%3Cpath class='cls-1' d='M13.5.75H9a1.5,1.5,0,0,0-1.5,1.5v1.5H15V2.25A1.5,1.5,0,0,0,13.5.75Z'/%3E%3Cline class='cls-1' x1='9' y1='16.5' x2='9' y2='9'/%3E%3Cline class='cls-1' x1='13.5' y1='16.5' x2='13.5' y2='9'/%3E%3Cpath class='cls-1' d='M18.11,20.37a1.49,1.49,0,0,1-1.49,1.38H5.88a1.49,1.49,0,0,1-1.49-1.38L3,3.75H19.5Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  display: inline-block;
  width: 14px;
  height: 14px;
  position: absolute;
  margin-left: -20px;
}

.invitee-question.disabled .question_title {
  opacity: 0.3;
}

.invitee-question.disabled .answer_type_input {
  opacity: 0.5;
}

#question_answers_cont {
  padding-bottom: 10px;
}
#question_answers_cont .txt-h5 {
  position: relative;
}
#question_answers_cont .reorder-handle {
  position: absolute;
  margin-left: -19px;
  margin-top: -4px;
  background-color: #fff;
  width: 8px;
  height: 20px;
  z-index: 1;
  border: 1px solid #b1b6d1;
  border-right: 0;
  border-radius: 5px 0px 0px 5px;
  cursor: ns-resize;
}
#question_answers_cont .reorder-handle::before {
  content: "";
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 13'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23b0b5d2;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Ccircle class='cls-1' cx='4.5' cy='1.5' r='1.5'/%3E%3Ccircle class='cls-1' cx='4.5' cy='5.5' r='1.5'/%3E%3Ccircle class='cls-1' cx='4.5' cy='9.5' r='1.5'/%3E%3Ccircle class='cls-1' cx='1.5' cy='3.5' r='1.5'/%3E%3Ccircle class='cls-1' cx='1.5' cy='7.5' r='1.5'/%3E%3Ccircle class='cls-1' cx='1.5' cy='11.5' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  width: 6px;
  height: 13px;
  top: 3px;
  left: 3px;
}
#edit_question_popup .popper_arrow::before {
  background: #b1b6d1;
}
</style>
